import { Form, Modal } from "antd";
import { useEffect } from "react";
import TopicQuestions from "../Topics/TopicQuestions";
import { StyledTopicModalDiv } from "../Topics/styles";

const AddEditQuestionModal = ({ onCancel, onSave, selectedQuestion }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    const question = selectedQuestion?.id
      ? selectedQuestion
      : {
          id: `${Date.now()}-${Math.random()}`,
          question: "",
          type: "string",
          options: [],
          order: 1,
        };

    form.setFieldsValue({
      questions: [question],
    });
  }, [selectedQuestion, form]);

  return (
    <Modal
      title={selectedQuestion?.id ? "Edit Question" : "Add Question"}
      onCancel={onCancel}
      width={500}
      open
      onOk={() => form.submit()}
    >
      {/* @ts-ignore */}
      <StyledTopicModalDiv isWorkflow>
        <Form form={form} layout="vertical" onFinish={onSave}>
          <TopicQuestions form={form} isWorkFlow />
        </Form>
      </StyledTopicModalDiv>
    </Modal>
  );
};

export default AddEditQuestionModal;
